// src/App.jsx
import { MantineProvider } from "@mantine/core";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import CustomerForm from "./pages/CustomerForm";
import BookingDetails from "./pages/BookingDetails";
import ProductScreen from "./pages/ProductScreen";
import Pricing from "./pages/Pricing";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Terms from "./pages/Terms";
import "@mantine/core/styles.css";
import "@mantine/dates/styles.css";
import { BookingProvider } from "./context/BookingContext";
import Navbar from "./pages/Navbar";

export default function App() {
  return (
    <MantineProvider
      theme={{
        primaryColor: "orange",
        fontFamily: "Inter, sans-serif",
        colors: {
          orange: [
            "#fff3e0", "#ffe0b2", "#ffcc80", "#ffb74d",
            "#ffa726", "#ff9800", "#f24c1a", "#e64a19",
            "#d84315", "#bf360c",
          ],
        },
      }}
    >
      <BookingProvider> {/* ✅ ADD THIS */}
        <BrowserRouter>
          <Navbar />
          <Routes>
            <Route path="/" element={<CustomerForm />} />
            <Route path="/booking" element={<BookingDetails />} />
            <Route path="/product" element={<ProductScreen />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/policy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </BrowserRouter>
      </BookingProvider>
    </MantineProvider>
  );
}